import { Link, useRouteLoaderData } from 'react-router-dom';
import { Card } from '@dma/ui';
import type { AdminSession } from '../domain/entities/AdminSession.entity';
import './AdminDashboardPage.css';

const ROLE_LABELS: Record<string, string> = {
  super_admin: 'مدیر ارشد',
  editor: 'ویرایشگر',
  viewer: 'بازدیدکننده'
};

/**
 * Landing page of the admin panel. Reads the session via
 * `useRouteLoaderData('admin-root')` rather than its own `useLoaderData()` —
 * the guard already ran once on the parent `admin` route (see
 * app/routes.tsx); giving this index route a second loader would just
 * re-fetch the same session on every navigation to `/admin`.
 */
export function AdminDashboardPage() {
  const session = useRouteLoaderData('admin-root') as AdminSession;
  const roleLabel = ROLE_LABELS[session.user.role] ?? session.user.role;

  return (
    <div className="dma-admin-dashboard">
      <h1 className="dma-admin-dashboard__title">خوش آمدید</h1>
      <p className="dma-admin-dashboard__subtitle">
        وارد شده با نقش <strong>{roleLabel}</strong>
      </p>

      <div className="dma-admin-dashboard__grid">
        <Link to="/admin/banner" className="dma-admin-dashboard__section-card">
          <h2>بنر صفحه اصلی</h2>
          <p>تنظیم تصویر بنر بالای صفحه اصلی سایت</p>
        </Link>
        <Link to="/admin/mineralogy" className="dma-admin-dashboard__section-card">
          <h2>کانی‌شناسی</h2>
          <p>افزودن و ویرایش مطالب علمی کانی‌ها</p>
        </Link>
        <Link to="/admin/petrology" className="dma-admin-dashboard__section-card">
          <h2>سنگ‌شناسی</h2>
          <p>افزودن و ویرایش مطالب علمی سنگ‌ها</p>
        </Link>
        <Link to="/admin/news" className="dma-admin-dashboard__section-card">
          <h2>اخبار</h2>
          <p>افزودن و ویرایش اخبار شرکت</p>
        </Link>
        <Link to="/admin/articles" className="dma-admin-dashboard__section-card">
          <h2>مقالات</h2>
          <p>افزودن و ویرایش مقالات تخصصی</p>
        </Link>
      </div>

      <Card className="dma-admin-dashboard__card">
        <h2 className="dma-admin-dashboard__card-title">در دست ساخت</h2>
        <p className="dma-admin-dashboard__card-text">
          مدیریت پروژه‌ها، خدمات و گالری از طریق فایل‌های محتوای ثابت (static) انجام می‌شود و در فاز
          بعدی به همین پنل منتقل خواهند شد.
        </p>
      </Card>
    </div>
  );
}
